import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import ReportSection from "./ReportSection";
import ReportDailySales from "./reportsales/ReportDailySales";
import checkPermission from "../../utils/CheckPermission";
import {
  isBC,
  isOwner,
  isSuperAdmin,
  isFinance,
  isCashier,
} from "../../utils/jelim/CheckUserType";
import { is } from "date-fns/locale";

const title = "Laporan";

const ReportMainPage = () => {
  const dispatch = useDispatch();
  const employee = useSelector((state) => state.auth.employee);
  const userType = employee ? employee.user_type : -1;
  // checkPermission("view report");

  const [showReportDailySales, setShowReportDailySales] = useState(false);

  var dataSalesDetails = [];

  if (
    isOwner(userType) ||
    isSuperAdmin(userType) ||
    isFinance(userType) ||
    isCashier(userType)
  ) {
    dataSalesDetails.push({
      id: "0-1",
      title: "Summary Sales Report (POS)",
      description: "Summarize daily sales activity",
      url: "/report/zzzz",
      on_click: (e) => setShowReportDailySales(true),
    });
  }

  if (isOwner(userType) || isSuperAdmin(userType) || isFinance(userType)) {
    dataSalesDetails.push({
      id: "0-2",
      title: "Detail Sales Report",
      description: "Detail sales, sorted by sales number and date",
      url: "/report/detail-sales-report",
    });
    dataSalesDetails.push({
      id: "0-3",
      title: "Sales Item Report",
      description: "List of sales items, grouped by category and date",
      url: "/report/sales-item-report",
    });
  }

  var dataSales = {
    id: "0",
    title: "Sales",
    details: dataSalesDetails,
  };

  var dataCustomerDetails = [];

  // if (isOwner(userType) || isSuperAdmin(userType) || isFinance(userType)) {
  // }

  if (
    isOwner(userType) ||
    isSuperAdmin(userType) ||
    isFinance(userType) ||
    isBC(userType)
  ) {
    dataCustomerDetails.push({
      id: "1-1",
      title: "Remaining Package",
      description: "List customer's remaining package free item",
      url: "/report/customer-remaining-package-report",
    });
    dataCustomerDetails.push({
      id: "1-2",
      title: "Remaining Package By Package Item",
      description:
        "List customer's remaining package free item, grouped by package free item",
      url: "/report/customer-remaining-package-by-package-item-report",
    });
    dataCustomerDetails.push({
      id: "1-3",
      title: "Remaining Package By Bought Package Name",
      description:
        "List customer's remaining package free item, grouped by bought package name",
      url: "/report/customer-remaining-package-by-package-name-report",
    });
    dataCustomerDetails.push({
      id: "1-4",
      title: "Customer Sales Report",
      description: "Sales report data grouped by customer",
      url: "/report/customer-sales-report",
    });
    dataCustomerDetails.push({
      id: "1-5",
      title: "Customer Expiring Point Report",
      description:
        "List all customer's point that will be expired at the end of month",
      url: "/report/report-expiring-customer-point",
    });
    dataCustomerDetails.push({
      id: "1-6",
      title: "Remaining Package Per Product Per Customer",
      description:
        "List customer's remaining package free item, grouped by product and customer",
      url: "/report/remaining-package-per-product-per-customer-report",
    });
  }

  var dataCustomer = {
    id: "1",
    title: "Customer",
    details: dataCustomerDetails,
  };

  var dataProductDetails = [];

  if (
    isOwner(userType) ||
    isSuperAdmin(userType) ||
    isFinance(userType) ||
    isBC(userType)
  ) {
    dataProductDetails.push({
      id: "2-1",
      title: "Product Customer Summary",
      description:
        "Per-product buyer count, quantity, and rebuy percentage over a date range",
      url: "/report/product-customer-summary-report",
    });
    dataProductDetails.push({
      id: "2-2",
      title: "Product Customer List",
      description:
        "List of customers who bought a specific product, with buy/use/remaining quantities",
      url: "/report/product-customer-list-report",
    });
  }

  var dataProduct = {
    id: "2",
    title: "Product",
    details: dataProductDetails,
  };

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return (
    <section className="row-start-start w-100 wrap p-4 gap-4">
      <ReportDailySales
        visible={showReportDailySales}
        onHide={(e) => setShowReportDailySales(false)}
      />

      <div className="row-start-start gap-5 grow">
        {dataSalesDetails.length > 0 ? (
          <ReportSection {...dataSales} key={dataSales.id} />
        ) : null}
        {dataCustomerDetails.length > 0 ? (
          <ReportSection {...dataCustomer} key={dataCustomer.id} />
        ) : null}
        {dataProductDetails.length > 0 ? (
          <ReportSection {...dataProduct} key={dataProduct.id} />
        ) : null}
      </div>
      {/* <div className="col-start-start gap-5 grow"></div> */}
    </section>
  );
};

export default ReportMainPage;
